module.exports = __webpack_public_path__ + "img/宣传页1.42b73464.jpg";